import './App.css';
import { BrowserRouter, Route, Routes, Navigate, useParams } from 'react-router-dom';
import Login from './components/auth/Login';
import NavBar from './components/common/NavBar';
import { useGlobal } from './contexts/GlobalContext';
import UserProfile from './components/auth/UserProfile';
import ManageOrders from './components/store/ManageOrders';
import { Container, Spinner } from 'react-bootstrap';
import Footer from './components/common/Footer';
import { ReactNode } from 'react';
import { Utils } from './common/Utils';

function App() {
  const { user, userloaded, settingsLoaded, settings, site, isAdmin } = useGlobal();
  document.title = settings.siteTitle;

  const LoginRedirect = () => {
    const { returnpath } = useParams();
    return <Navigate to={Utils.GetUrl(`/${returnpath}`)} replace />;
  };

  if (!settingsLoaded || !userloaded) {
    return <Container className="d-flex flex-column justify-content-center align-items-center vh-100">
      {settings && settings.siteLoadingIcon ? <img src={settings.siteLoadingIcon} alt="Centered" className="img-fluid" /> : <Spinner animation="border" variant="primary" role="status"></Spinner>}
    </Container>
  }
  else if (!settings || settings.isDefault) {

    if (site && !site.siteLoaded) {
      return <Container className="d-flex flex-column justify-content-center align-items-center vh-100">
        {<><img src="/icon2.png" alt="Centered" className="img-fluid" /><br /><h2 style={{ color: "#304768" }}>Site Under Construction</h2><h4 style={{ color: "#304768" }}>Please try again later.</h4></>}
      </Container>
    }

    return <Container className="d-flex flex-column justify-content-center align-items-center vh-100">
      {<><img src="/icon2.png" alt="Centered" className="img-fluid" /><br /><h2 style={{ color: "#304768" }}>Store Not Found</h2></>}
    </Container>
  }

  interface RedirectIfAuthenticatedProps {
    children: ReactNode;
  }

  const RedirectIfNotAuth: React.FC<RedirectIfAuthenticatedProps> = ({ children }) => {
    return user ? <>{children}</> : <Navigate to={Utils.GetUrl("/login")} />;
  };

  const RedirectIfAdminNotAuth: React.FC<RedirectIfAuthenticatedProps> = ({ children }) => {
    return user && isAdmin ? <>{children}</> : user ? <Navigate to="/" /> : <Navigate to={Utils.GetUrl("/login")} />;
  };

  return (
    <>
      {settings && settings.siteFavicon && <link rel='icon' href={settings.siteFavicon}></link>}
      {site && site.package !== "Starter" && settings && settings.siteCSS && settings.siteCSS !== "" && <style dangerouslySetInnerHTML={{ __html: settings.siteCSS.replace(/\n/g, '').trim() }} />}
      <BrowserRouter>
        <NavBar />
        <Routes>
          <Route path="/" element={<RedirectIfAdminNotAuth><ManageOrders /></RedirectIfAdminNotAuth>} />
          <Route
            path="/login/:returnpath"
            element={user ? <LoginRedirect /> : <Login />}
          />
          <Route
            path="/login"
            element={user ? <Navigate to={Utils.GetUrl("/orders")} /> : <Login />} // Redirect if logged in
          />

          <Route path="/orders" element={<RedirectIfAdminNotAuth><ManageOrders /></RedirectIfAdminNotAuth>} />
          <Route path="/userprofile" element={<RedirectIfNotAuth><UserProfile /></RedirectIfNotAuth>} />

          <Route path="/:alias/" element={<RedirectIfAdminNotAuth><ManageOrders /></RedirectIfAdminNotAuth>} />
          <Route
            path="/:alias/login/:returnpath"
            element={user ? <LoginRedirect /> : <Login />}
          />
          <Route
            path="/:alias/login"
            element={user ? <Navigate to={`/${Utils.GetAlias()}`} /> : <Login />} // Redirect if logged in
          />
          <Route path="/:alias/userprofile" element={<RedirectIfNotAuth><UserProfile /></RedirectIfNotAuth>} />

        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
